import { ICronJobByIdRespDto, IUpdateCronJobDto } from 'src/types/cron-jobs.type'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { IMessageResponseDto } from 'src/types'

class CroneJobsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getAllCronJobs() {
    return this.get<ICronJobByIdRespDto[]>(`crone-jobs/all`, {})
  }

  updateCronJob(id: string, dto: IUpdateCronJobDto) {
    return this.put<IMessageResponseDto, IUpdateCronJobDto>(`crone-jobs/status/${id}`, dto)
  }

  updateEsgTrends() {
    return this.put<IMessageResponseDto, {}>(`crone-jobs/esg-trends`, {})
  }

  updateCointelegraphTrends() {
    return this.put<IMessageResponseDto, {}>(`crone-jobs/cointelegraph-trends`, {})
  }

  sendTgScanApprovedDailyMessage() {
    return this.put<IMessageResponseDto, {}>(`crone-jobs/tg-approved-daily`, {})
  }

  approveAllConsumerScans(challange: string | null) {
    return this.post<IMessageResponseDto, {}>(`crone-jobs/s2e-approve-all-scans`, { challange })
  }

  sendMissingDecryptedTx() {
    return this.post<IMessageResponseDto, {}>(`crone-jobs/s2e-send-missing-decrypted-tx`, {})
  }

  sendMissingEncryptedTx() {
    return this.post<IMessageResponseDto, {}>(`crone-jobs/s2e-send-missing-encrypted-tx`, {})
  }
}

export const croneJobsService = new CroneJobsService()
export default CroneJobsService
